var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2138_11189)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0529,
    cy: 31.9999,
    rx: 31.839,
    ry: 31.746,
    fill: "#D2D7E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.30566,
    y: 9.72266,
    width: 51.4943,
    height: 31.5725,
    rx: 4,
    fill: "#9AA4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2059 39.8309L40.2803 25.5071L57.2059 11.1833C57.3505 11.0989 57.4319 10.9377 57.4136 10.7716C57.3953 10.6055 57.2808 10.4657 57.1212 10.4147C56.9617 10.3638 56.7869 10.4111 56.6752 10.5356L34.9525 28.906C33.2811 30.3239 30.825 30.3239 29.1536 28.906L7.43087 10.5356C7.25151 10.3849 6.98352 10.4076 6.8323 10.5864C6.68108 10.7653 6.70388 11.0325 6.88324 11.1833L23.8258 25.5071L6.90022 39.8309C6.74564 39.9104 6.65538 40.076 6.67247 40.2486C6.68956 40.4212 6.81054 40.5659 6.97774 40.6138C7.14494 40.6617 7.32451 40.6031 7.43087 40.4658L24.4839 26.0743L28.6059 29.5621C30.5904 31.255 33.5157 31.255 35.5002 29.5621L39.6222 26.0743L56.6752 40.4658C56.751 40.5304 56.8472 40.5664 56.9469 40.5674C57.1247 40.5674 57.2836 40.457 57.3452 40.2907C57.4068 40.1245 57.3579 39.9376 57.2229 39.8224L57.2059 39.8309Z",
    fill: "#62719A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3524 42.6958L32.9785 36.3466C32.4466 35.8897 31.6594 35.8897 31.1276 36.3466L23.7536 42.6958C23.5107 42.886 23.4182 43.2106 23.5246 43.4998C23.6309 43.789 23.9119 43.977 24.2206 43.9656H27.1201V53.3836C27.1201 53.6268 27.2173 53.86 27.3902 54.0316C27.563 54.2032 27.7974 54.299 28.0413 54.2979H36.0647C36.3087 54.299 36.543 54.2032 36.7159 54.0316C36.8888 53.86 36.9859 53.6268 36.9859 53.3836V43.9445H39.8854C40.1832 43.9445 40.4497 43.76 40.5538 43.4818C40.6578 43.2036 40.5775 42.8902 40.3524 42.6958Z",
    fill: "#D93954"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2138_11189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactModal);
export default __webpack_public_path__ + "static/media/contact_modal.f5cb7b2530336d4807894c9535dabcd7.svg";
export { ForwardRef as ReactComponent };